import { render } from "./EmailPrivacy.vue?vue&type=template&id=546bfe54&scoped=true"
import script from "./EmailPrivacy.vue?vue&type=script&lang=js"
export * from "./EmailPrivacy.vue?vue&type=script&lang=js"

import "@/assets/css/about.css?vue&type=style&index=0&id=546bfe54&scoped=true&lang=css"
import "./EmailPrivacy.vue?vue&type=style&index=1&id=546bfe54&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-546bfe54"]])

export default __exports__